import { render } from "./badge-transaction-type.vue?vue&type=template&id=2e2576d3"
import script from "./badge-transaction-type.vue?vue&type=script&lang=js"
export * from "./badge-transaction-type.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__